import { baseResponse } from "./helpers/baseResponse";

const orgURL = s => `/api/dynamics/organizations/${s}`;

export const organizationAPI = {
  async updateUsers(formParams) {
    const apiResponse = await axios.post(orgURL('user/update'), formParams).catch(r => r.response);
    return baseResponse(apiResponse);
  },
  async updateBasicProfile(formParams) {
    const apiResponse = await axios.post(orgURL('profile/update/basic'), formParams).catch(r => r.response);
    return baseResponse(apiResponse);
  },
  async updateProfileReimagine(formParams) {
    const apiResponse = await axios.post(orgURL('profile/update/reimagine'), formParams).catch(r => r.response);
    return baseResponse(apiResponse);
  },
  async updateProfileStory(formParams) {
    const apiResponse = await axios.post(orgURL('profile/update/story'), formParams).catch(r => r.response);
    return baseResponse(apiResponse);
  }
};
